import {AxiosRequestConfig} from 'axios';
import request from '../../../axios';

export const deleteAdvertisment = async (guid: string, filter: string) => {
  const {data}: {data: IResponse} = await request.delete(
    `/api/v2/store/advertisement/${guid}`,
    {
      params: {filter: filter},
    } as AxiosRequestConfig,
  );
  return data;
};
